import { render, staticRenderFns } from "./VvSpeechButton.vue?vue&type=template&id=0fc86c3e&scoped=true&"
import script from "./VvSpeechButton.vue?vue&type=script&lang=js&"
export * from "./VvSpeechButton.vue?vue&type=script&lang=js&"
import style0 from "./VvSpeechButton.vue?vue&type=style&index=0&id=0fc86c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc86c3e",
  null
  
)

export default component.exports